import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  max-width: 1300px;
  margin: 100px auto 0;
  padding: 1rem;
`

export const HeaderCard = styled.div`
  .back-button {
    display: flex;
    align-items: center;
    gap: 6px;

    background: none;
    border: none;
    margin: 0;
    margin-bottom: 1rem;
    font-weight: bold;
    font-size: 14px;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }
`
export const Card = styled.div`
  width: auto;
  height: auto;
  hr {
    mix-blend-mode: normal;
    border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  }
`
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 18rem;
  width: 100%;
  background-color: ${({ theme }) => `rgb(${theme.background.high})`};
  margin-bottom: 0.5rem;
  border-radius: 8px;
  border: solid 2px ${({ theme }) => `rgb(${theme.component.accent})`};

  .loading-block {
    &.line {
      display: inline-block;
      width: 160px;
      height: 12px;
    }

    &.block-line {
      display: block;
      width: 100%;
      height: 12px;

      margin-bottom: 8px;
    }
  }
`
export const TitleCard = styled.div`
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // align-items: center;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  line-height: 136%;
  font-size: 18px;
  margin-left: 1rem;

  .header-title {
    display: flex;
    flex-direction: column;
    margin: 0;
    margin-top: 2rem;
    padding: 0;

    h3 {
      font-size: 1.25rem;
      margin: 0;
    }
    p {
      font-size: 14px;
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
      font-weight: 500;
      margin-top: 0;
    }
  }
`
export const HeaderContendCard = styled.div`
  margin: 0 1rem 1rem !important;

  .course-name {
    font-size: 1rem;
    line-height: 1.7rem;

    font-weight: bold;
  }

  .link {
    text-decoration: underline;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    transition: 200ms color ease;

    &:hover {
      color: ${({ theme }) => `rgb(${theme.primary.base})`};
    }
  }

  p {
    margin: 0;
    font-size: 0.75rem;
    line-height: 1.5rem;
    color: ${({ theme }) => `rgba(${theme.grayscale[200]})`};
    font-weight: 500;
  }

  div {
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
  }

  h3 {
    font-size: 1rem;
    line-height: 1.375rem;
    font-style: italic;
    font-weight: 500;
    color: ${({ theme }) => `rgba(${theme.background.high})`};
    margin: 0;
    width: 100%;
    border-left: 3px solid ${({ theme }) => `rgb(${theme.primary.base})`};
    background: ${({ theme }) => `rgb(${theme.primary[300]})`};
    padding: 0.5rem;
  }

  button {
    width: fit-content;

    font-weight: 700;

    background: transparent;

    margin-top: 0.5rem;
    padding: 0.5rem 1rem;

    border-radius: 4px;
    border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.8)`};
  }

  @media only screen and (min-width: 600px) {
    display: flex;
    flex-direction: column;
    margin: 0;
    margin-left: 1rem;
  }
  @media only screen and (min-width: 1024px) {
    display: flex;
    // flex-direction: row-reverse;
    min-width: 60rem;
    margin: 1rem;
    div {
      display: flex;
      flex-direction: row;
      justify-content: end;
      align-items: center;
      // width: 40%;
      h3 {
        margin-left: 0.5rem;
      }
    }
    span {
      width: 60%;
    }
  }
`

export const Content = styled.div`
  padding: 20px;
`
